'use client';

import Image from 'next/image';
import {useState} from 'react';
import type {SummaryCompany} from 'iq-onboarding/types';

export function CompanyPill({company}: {company: SummaryCompany}) {
  const [logoFailed, setLogoFailed] = useState(false);
  const showLogo = company.logo && !logoFailed;

  return (
    <span className='inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded border border-iq-grey-light text-iq-grey-dark whitespace-nowrap'>
      {showLogo && (
        <Image
          // Request a 40px-wide logo from the CDN (`/w/40` before any query string).
          src={company.logo.replace(/(\?|$)/, '/w/40$1')}
          alt={company.name}
          width={16}
          height={16}
          className='rounded-sm object-contain'
          unoptimized
          onError={() => setLogoFailed(true)}
        />
      )}
      {company.name}
    </span>
  );
}
